import React from 'react';

const TableRow = props => {
  const { data, rowClassName = '', columnNum = 7 } = props;
  const formattedData = Array.from({ length: columnNum }, (_, n) => data[n] ?? {});
  
  return (
    <div className={`table-row row ${rowClassName}`}>
      {formattedData.map(({ value, CellComponent = 'span', cellClassName, cellProps }, i) => (
        <CellComponent key={i} className={cellClassName} {...cellProps}>{value}</CellComponent>
      ))}
    </div>
  );
};

export default TableRow;